import {MOON_50} from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner, BannerBoldText} from '../../Banner';

export const Panel = styled.div`
  flex: 1 1 auto;
  height: 100%;
  background-color: ${MOON_50};
`;
Panel.displayName = 'S.Panel';

export const BannerWithMargin = styled(Banner)`
  margin: 8px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const PointerBoldText = styled(BannerBoldText)`
  cursor: pointer;
`;
PointerBoldText.displayName = 'S.PointerBoldText';

export const Link = styled(TargetBlank)`
  margin-left: 4px;
`;
Link.displayName = 'S.Link';
